import { facadeApi } from 'api'
import { TenantAccessRequest } from 'types/requests/requests'

export interface Params {
  id: string
}

export const fetchTenantAccessRequestApi = ({ id }: Params) =>
  facadeApi.get<TenantAccessRequest>(`/access-requests/${id}`)
